import React, { Component } from 'react';
import axios from 'axios';
import BlockUi from 'react-block-ui';
import { Loader } from 'react-loaders';
import RegularConfigureModel from './regularConfigureModel';
import LayoutWithHeader from '../../component/layoutWithHeader';
import PageNotFound from '../../component/404';
import RegularAdmin from '../regularLogin/model/regularAdmin';
import { getTenantInfo, addSubGeneral } from '../../api';
import {checkdomain} from "../../utils/utils";

class RegularConfig extends Component{
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      companyName: '',
      headlineColor: '',
      pageNotFound: false,
      logo: '',
      expire: false,
      expireMsg: '',
      flag: ''
    };
  }

  componentDidMount() {
    this._eventHandler();
    let { email } = this.props.match.params;
    let t = this.props.match.params.t;
    sessionStorage.setItem("token", t);
    let tenantname = location.hostname.split('.')[0].split('-')[0];
    if (checkdomain(tenantname)) {
      return this.props.history.push("/admin");
      // return this.setState({pageNotFound: true});
    }
    this.setState({name: tenantname});
    getTenantInfo({}, {headers: {'tenantname': tenantname}})
      .then(res => {
        this.setState({
          companyName: res.data.companyName,
          logo: res.data.logo,
          headlineColor: res.data.headlineColor
        })
      })
      .catch(err=>{
        console.log(err);
        if (err.message && err.message === "The tenant was not found.") {
          this.setState({pageNotFound: true});
        }
      });
    axios.get(`/api/subscribe/regionalsubscription/${email}`, {headers: {'tenantname': tenantname, 'token': t}})
      .then(res=>{
        this.setState({
          expire: false,
          flag: 'ok'
        });
      })
      .catch(err=>{
        console.log(err);
        this.setState({
          expire: true,
          flag: 'ok'
        });
        if (err.message === "Email address is invalid.") this.setState({expireMsg: err.message});
      });
  }
  _eventHandler = () => {
    let _submitHandler = this._submitHandler;
    let _resetForm = this._resetForm;
    $(document).on("click",".close",function(){
      _resetForm();
      $("#addrow_modal").modal("hide");
    });
    $("#regionalForm").validate({
      rules: {
        email: {required: true, email: true},
        clientId:{required:true}
      },
      messages: {
        email: {
          required: 'Please enter your email address',
          email: 'Please enter a valid email address'},
        clientId:{
          required: 'Please enter a company name'}},
      submitHandler:function(){
        _submitHandler();
      },
      errorPlacement: function (error, element) {
        error.insertAfter(element.parent());
      }
    });
  };
  _submitHandler = () => {
    let clientId = $("#clientId").val();
    let email = $("#email").val();
    let tenantName = this.state.name;
    addSubGeneral({clientId, email, tenantName})
      .then(res=>{
        if (res.status === "success") {
          $.sound_on = false;
          $.bigBox({
            title : "Email notification",
            content : "You have successfully added subscribers.",
            color : "#739E73",
            timeout: 6000,
            icon : "fa fa-check",
            number : "Congratulation"
          });
          this._resetForm();
          $("#addrow_modal").modal("hide");
        }
      })
      .catch(err=>{
        console.log(err);
      });
  };
  _resetForm = () => {
    $("#clientId").val("");
    $("#email").val("");
    $(".state-success").removeClass("state-success");
    $(".state-error").removeClass("state-error");
    $("em.invalid").remove();
  };

  render() {
    let { name, companyName, headlineColor, pageNotFound, logo, expire, expireMsg, flag } = this.state;
    let block = !flag;
    if (pageNotFound) {
      return <PageNotFound />;
    }
    return (
      <div>
        <LayoutWithHeader logo={logo}>
          <BlockUi tag="div"
                   loader={<Loader active type="ball-grid-pulse" color="#808080"/>}
                   blocking={block}
                   renderChildren={false}>
            {
              expire ?
                <RegularAdmin companyName={companyName} expire={expire} expireMsg={expireMsg} headlineColor={headlineColor} />
                :
                <RegularConfigureModel companyName={companyName} name={name} headlineColor={headlineColor} />
            }
          </BlockUi>
        </LayoutWithHeader>
        {/*add subscriber modal*/}
        <div className="modal fade"
             id="addrow_modal"
             role="dialog"
             aria-labelledby="myModalLabel"
             aria-hidden="true"
             data-backdrop="static">
          <div className="modal-dialog">
            <form id="regionalForm" className="form-horizontal">
              <div className="modal-content"
                   style={{backgroundColor: '#E6E6E6', borderRadius: 7}}>
                <div className="modal-header"
                     style={{borderTopRightRadius: 5, borderTopLeftRadius: 5}}>
                <span className="pull-right">
                  <i className=" close fa fa-lg fa-times" />
                </span>
                  <h4 className="modal-title"> Add subscriber</h4>
                </div>
                <div className="modal-body">
                  <div className="smart-form client-form">
                    <section className="form-group">
                      <label className="input">
                        <input id="clientId"
                               className="form-control"
                               name="clientId"
                               type="text"
                               placeholder="Please enter a company name" />
                        <b className="tooltip tooltip-top-right">
                          <i className="fa fa-tags txt-color-teal" />
                          Please enter a company name
                        </b>
                      </label>
                    </section>
                    <br />
                    <section className="form-group">
                      <label className="input">
                        <input id="email"
                               className="form-control"
                               name="email"
                               type="email"
                               placeholder="Please enter an email address" />
                        <b className="tooltip tooltip-top-right">
                          <i className="fa fa-envelope txt-color-teal" />
                          Please enter an email address
                        </b>
                      </label>
                    </section>
                  </div>
                </div>
                <div className="modal-footer" style={{borderTop: '1px solid #ababab'}}>
                  <button id="modalConfirm" type="submit" className="btn btn-primary">Confirm</button>
                  <button className="btn btn-success"
                          onClick={e=>{
                            e.preventDefault();
                            this._resetForm();
                          }}>
                    Clear
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default RegularConfig;


// WEBPACK FOOTER //
// ./src/container/regularConfigure/index.js